import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "sonner";
import ordersService from "../../../api/services/orders";

// Create a new order
export const createOrder = createAsyncThunk(
  "orders/create",
  async (orderData, { rejectWithValue }) => {
    try {
      const response = await ordersService.createOrder(orderData);
      toast.success("Porudžbina je uspešno kreirana!");
      return response;
    } catch (error) {
      const message = error.message || "Greška prilikom kreiranja porudžbine";
      toast.error(message);
      return rejectWithValue(message);
    }
  }
);

// Get user's orders
export const getUserOrders = createAsyncThunk(
  "orders/getUserOrders",
  async (_, { rejectWithValue }) => {
    try {
      const response = await ordersService.getUserOrders();
      return response;
    } catch (error) {
      const message = error.message || "Greška prilikom dohvatanja porudžbina";
      toast.error(message);
      return rejectWithValue(message);
    }
  }
);

// Get order by ID
export const getOrderById = createAsyncThunk(
  "orders/getById",
  async (orderId, { rejectWithValue }) => {
    try {
      const response = await ordersService.getOrderById(orderId);
      return response;
    } catch (error) {
      const message = error.message || "Greška prilikom dohvatanja porudžbine";
      toast.error(message);
      return rejectWithValue(message);
    }
  }
);

export const exportOrders = createAsyncThunk(
  "admin/exportOrders",
  async (filters, { rejectWithValue }) => {
    try {
      const response = await ordersService.exportOrders(filters);
      return response; // ordersService.exportOrders već vraća response.data
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Greška pri izvozu" }
      );
    }
  }
);
